import { createContext, useContext } from 'react';

import { type AdvancedFiltersContextValue } from './ChangeFiltersPopoverView.reducer';

export const ChangeFiltersPopoverViewContext =
  createContext<AdvancedFiltersContextValue | null>(null);

export const useChangeFiltersPopoverViewContext = () => {
  const context = useContext(ChangeFiltersPopoverViewContext);

  if (!context) {
    throw new Error(
      'useChangeFiltersPopoverViewContext must be used within a ChangeFiltersPopoverViewContextProvider',
    );
  }

  return context;
};
